// extracted by mini-css-extract-plugin
export default {"button":"DefaultButton_button__sVEhG","disabled":"DefaultButton_disabled__uPMny"};